export default {
  text: 'El mapa lo proporciona Google. Al cargarlo, se envía tu dirección IP a Google.',
  buttons: {
    show_map: 'Mostrar mapa',
    retry: 'Intentar de nuevo',
  },
  errors: {
    map_unavailable: 'No se pudo cargar el mapa.',
  },
};
